module.exports = __webpack_public_path__ + "static/media/switch.8b4f0e07.svg";